<template>
    <VinQuery 
      class="ota-query-page"
      :main-title="mainTitle"
      :sub-title="subTitle"
      :remark="remark"
      :form="form"
      :loading="loading"
      :init="init"
      :query-method="handleQuery"
    >
      <!-- 成功结果 -->
      <template #SuccessContent v-if="successObj &&Object.prototype.toString.call(successObj) === '[object Object]'&&Object.keys(successObj).length > 0">
        <SuccessContent
          :main-title=successObj?.title
          :hints="[successObj?.content,successObj?.content_one]"
          button-text="确认"
          :confirm-method="handleSuccessConfirm"
       >
          <template #icon>
            <div class="default-icon">
             <svg viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="76.000000" height="76.000000" fill="none" customFrame="#000000">
                <g id="提交成功">
                  <path id="矢量 29" d="M76 38C76 58.9846 58.9846 76 38 76C17.012 76 0 58.9846 0 38C0 17.012 17.0154 0 38 0C58.9846 0 76 17.0154 76 38Z" fill="rgb(22,189,51)" fill-opacity="0.100000001" fill-rule="nonzero" />
                  <path id="矢量 30" d="M49.9146 26.555C50.2865 26.1765 50.7542 25.9022 51.2697 25.7601C51.7852 25.618 52.3298 25.6134 52.8477 25.7466C53.3656 25.8799 53.8381 26.1462 54.2166 26.5182C54.5952 26.8903 54.8661 27.3547 55.0017 27.8637C55.1372 28.3727 55.1325 28.908 54.988 29.4146C54.8434 29.9212 54.5643 30.3809 54.1792 30.7465L36.0833 48.5321C35.709 48.8999 35.2427 49.1644 34.7315 49.2991C34.2202 49.4337 33.6818 49.4337 33.1706 49.2991C32.6593 49.1644 32.193 48.8999 31.8187 48.5321L22.7707 39.6393C22.3857 39.2738 22.1065 38.8141 21.962 38.3074C21.8174 37.8008 21.8127 37.2655 21.9483 36.7565C22.0838 36.2475 22.3548 35.7831 22.7333 35.411C23.1119 35.039 23.5844 34.7727 24.1023 34.6394C24.6202 34.5062 25.1648 34.5108 25.6803 34.6529C26.1957 34.795 26.6634 35.0693 27.0354 35.4478L33.951 42.2449L49.9146 26.555Z" fill="rgb(22,189,51)" fill-rule="nonzero" />
                </g>
              </svg>

            </div>
                
          </template>
      </SuccessContent>
      </template>

      <!-- 失败结果 -->
      <template #FailContent v-if="failObj">
        <FailContent
          :main-title=failObj?.title
          :hints="[failObj?.content]"
          button-text="确认"
          :confirm-method="handleFailConfirm"
       >
          <template #icon>
            <div class="default-icon">
              <svg viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="76.000000" height="76.000000" fill="none">
              <rect id="错误 1" width="76.000000" height="76.000000" x="0.000000" y="0.000000" />
              <path id="矢量 44" d="M38 0C31.3296 0 24.7767 1.75584 19 5.09104C13.2233 8.42623 8.42623 13.2233 5.09104 19C1.75584 24.7767 0 31.3296 0 38C0 44.6704 1.75584 51.2233 5.09104 57C8.42623 62.7767 13.2233 67.5738 19 70.909C24.7767 74.2442 31.3296 76 38 76C44.6704 76 51.2233 74.2442 57 70.909C62.7767 67.5738 67.5738 62.7767 70.909 57C74.2442 51.2233 76 44.6704 76 38C76 31.3296 74.2442 24.7767 70.909 19C67.5738 13.2233 62.7767 8.42623 57 5.09103C51.2233 1.75584 44.6704 0 38 0Z" fill="rgb(252,234,231)" fill-rule="nonzero" />
              <path id="矢量 45" d="M38.1142 41.0083L29.3925 49.7301C29.1183 50.0041 28.7767 50.201 28.4022 50.301C28.0277 50.4009 27.6334 50.4004 27.2592 50.2995C26.8849 50.1985 26.5439 50.0007 26.2705 49.7259C25.9968 49.4505 25.8002 49.108 25.7004 48.7327C25.6007 48.3574 25.6012 47.9625 25.7019 47.5875C25.8027 47.2124 26.0002 46.8704 26.2746 46.5957L34.9881 37.8822L26.2333 29.1234C25.9246 28.8151 25.7214 28.417 25.6528 27.9861C25.5843 27.5552 25.6539 27.1137 25.8517 26.7249C26.0495 26.336 26.3653 26.0197 26.7539 25.8214C27.1425 25.623 27.5839 25.5528 28.0149 25.6207C28.4458 25.6887 28.8442 25.8913 29.1529 26.1996L49.8009 46.8476C50.1097 47.1563 50.3127 47.5549 50.381 47.9861C50.4493 48.4173 50.3793 48.8591 50.1811 49.2481C49.9829 49.6371 49.6666 49.9534 49.2776 50.1516C48.8886 50.3498 48.4469 50.4197 48.0156 50.3514C47.5844 50.2831 47.1859 50.0801 46.8772 49.7714L38.1142 41.0083ZM47.0093 26.1831C47.2489 25.9076 47.5596 25.7033 47.9075 25.5926C48.2554 25.4818 48.627 25.4689 48.9817 25.5552C49.3364 25.6414 49.6606 25.8236 49.9188 26.0818C50.1769 26.3399 50.3591 26.6641 50.4454 27.0188C50.5317 27.3736 50.5187 27.7452 50.408 28.0931C50.2972 28.4409 50.0929 28.7516 49.8175 28.9912L43.8295 35.1443C43.5846 35.4001 43.2759 35.586 42.9352 35.6826C42.5946 35.7793 42.2343 35.7834 41.8915 35.6944C41.5487 35.6054 41.2359 35.4266 40.9853 35.1763C40.7347 34.9261 40.5554 34.6135 40.4659 34.2709C40.3764 33.9283 40.3799 33.568 40.4761 33.2271C40.5723 32.8863 40.7577 32.5773 41.0131 32.3321L47.0093 26.179L47.0093 26.1831Z" fill="rgb(232,48,16)" fill-rule="nonzero" />
            </svg>

            </div>
          </template>
        </FailContent>
      </template>
    </VinQuery>
</template>
<script>
import VinQuery from '../pc/message/message-elements/vin-query/index.vue'
import SuccessContent from '../pc/message/message-elements/vin-query/success-content.vue'
import FailContent from '../pc/message/message-elements/vin-query/fail-content.vue'
import { VIN_ERROR_CODE } from '../pc/message/message-elements/vin-query/constant'
import sessionAPI from '@/api/session'

/**
 * 三张卡片的流程：
 * 1. 初始状态：通过this.init 传给组件vin-query/vin-queryindex.vue 用户输入车架号查询，系统返回查询结果。
 * 2. 命中OTA升级状态：
 * 2.1 更改相关状态
 * this.init=false;
 * this.failObj=undefined
 * this.successObj=res
 * 2.2 控制渲染
 * <template #SuccessContent v-if="successObj &&Object.prototype.toString.call(obj) === '[object Object]'&&Object.keys(successObj).length > 0" 判断渲染
 * 2.3 用户点击确认升级按钮，系统跳转至升级页面。
 * this.init=false;
 * this.successObj=undefined
 * 3. 未命中OTA升级状态：用户点击确认升级按钮，系统提示“您的车辆未命中OTA升级资格”。
*/
/*
 * OTA升级查询组件
 * 签名机制说明（车架号关联版）：
 * 1. 每次查询前根据当前车架号获取签名串（不再预加载）
 * 2. 查询OTA时携带签名串
 * 3. 签名过期(40015)时自动重新获取并重试（最多3次）
 * 4. 每次查询使用独立签名，避免车架号串号问题
 */
export default {
      components: { VinQuery, SuccessContent, FailContent },
      data() {
        return {
            // 背景的主标题、副标题、提示信息
             mainTitle:'车辆OTA升级查询',
             subTitle:'输入17位车架号，快速查询升级资格',
             remark:'温馨提示：OTA升级将依据整车软件版本状态推送，详询可咨询售后门店',
             // 表单中的title,placeholder,hint,buttonText
             form: {
               formTitle: '车辆车架号（VIN）',
               placeholder: '请输入17位车辆识别代码',
                hint:'车架号获取方法：1.比亚迪App/小程序【我的-车辆模型-车辆信息】长按复制；2.通过行驶证、车辆前挡风玻璃左下角查看；',
               buttonText: '立即查询升级范围',
               showHintPrefix:false
             },
             vinValue: '',
             // 命中OTA升级
            successObj:undefined,
            // 未命中OTA升级、其他错误等
            failObj:undefined,
            loading:false,
            // 当用户点击命中状态卡片按钮、非命中状态按钮才会回到初始值
            init:true,
            // 最大重试次数
            maxRetryCount: 3,
        }
      },
      methods: {
        /**
         * 获取OTA加密签名串（需要传车架号）
         * @param {string} vin - 车架号
         */
        async fetchEncryptData(vin) {
          try {
            console.log(`获取OTA加密签名串, 车架号: ${vin}`)
            const res = await sessionAPI.getVinEncryptStr({ param: vin })
           console.log('获取OTA加密签名串,res: ',res)
            return res?.data?.encryptData
          } catch (error) {
            console.error('获取加密签名串失败:', error)
            return null
          }
        },
        /**
         * OTA查询主方法（支持自动重试）
         * @param {string} vinValue - 车架号
         * @param {number} retryCount - 当前重试次数（内部使用，默认0）
         */
        async handleQuery(vinValue, retryCount = 0) {
          console.log(`OTA查询, 车架号: ${vinValue}, 重试次数: ${retryCount}`)
          
          this.vinValue = vinValue
          this.loading = true
          this.successObj = undefined
          this.failObj = undefined
          
          try {
            const encryptData = await this.fetchEncryptData(vinValue)
            if (!encryptData) {
              throw new Error('获取签名串失败')
            }
            
            // 携带 encryptData 调用接口
            const res = await sessionAPI.queryOTAUpdateWithVIN({ 
              vin: vinValue, 
              encryptData 
            })
            
            console.log('OTA查询结果:', res)
            if (res?.code === VIN_ERROR_CODE.EXPIRED_SIGN) {
              if (retryCount < this.maxRetryCount) {
                console.log(`签名过期(${VIN_ERROR_CODE.EXPIRED_SIGN})，第${retryCount + 1}次重试...`)
                return this.handleQuery(vinValue, retryCount + 1)
              } else {
                throw new Error('签名串获取失败，重试次数已达上限')
              }
            }
            
            // 处理正常业务逻辑
            const keys = Object.prototype.toString.call(res) === '[object Object]' ? Object.keys(res) : []
            
            // 当有OTA升级信息
            if (keys.includes('has_update') && res.has_update) {
              this.successObj = res
              this.init = false
            } 
            // 当无OTA升级信息
            else if (keys.includes('has_update') && !res.has_update) {
              this.failObj = res
              this.init = false
            } else {
              throw new Error('查询结果格式异常')
            }
            
          } catch (error) {
            console.error('OTA查询失败:', error)
             // 其他外层ret!=200,前端兜底文案
            this.failObj = {
               'has_update': false,
              'title': '车辆不在本次升级范围',
               'content': '可持续关注官方OTA升级通知',
            }
            this.init = false
          } finally {
            this.loading = false
          }
        },
        handleSuccessConfirm() {
          // 确认按钮点击事件
          console.log('确认升级')
          this.init=true
          this.successObj=undefined
         console.log('this.init==>',this.init)
        },
        handleFailConfirm() {
          // 失败状态确认按钮点击事件
          console.log('确认失败状态')
          this.init = true
          this.failObj = undefined
        }
      }
}
</script>
<style lang="less" scoped>
@import '../pc/message/message-elements/vin-query/common.less';

.default-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ota-query-page {
  background-image: url('~@/assets/image/ota_query.png');
  :deep(.remark){
    // form-wrapper和上面副标题的距离：138 - 66 - 48=24px
    // 24px+16px+form-wrapper的高度：24px+16px+234px=274px
    .px2rem(margin-top, 274);
  }
}
</style>
